<template>
  <v-app class="pa-6">
    <Header />
    <Sidebar v-if="renderComponent" />
    <v-main class="content">
      <router-view />
      <!-- <Footer /> -->
    </v-main>
    <v-dialog
      v-model="showDialog"
      max-width="290"
    >
      <v-card>
        <v-card-text>{{ dialogMsg }}</v-card-text>
        <!-- <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="dialog = false"
          >
            Disagree
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="dialog = false"
          >
            Agree
          </v-btn>
        </v-card-actions> -->
      </v-card>
    </v-dialog>
    <v-snackbar v-model="showSnackbar" :color="snackbarColor">
      {{ snackbarMsg }}
      <template v-slot:action="{ attrs }">
        <v-btn text small v-bind="attrs" @click="showSnackbar = false">
          X
        </v-btn>
      </template>
    </v-snackbar>
    <!-- <v-dialog v-model="showPopUpNotificationDialog" max-width="350">
      <v-card>
        <v-card-title class="subtitle-1 justify-center">
          PRODUK / INFORMASI PROGRAM BARU
        </v-card-title>
        <v-card-actions class="justify-center">
          <v-btn
            color="yellow"
            depressed
            @click="handlePopUpNotificationDialog"
            class="font-weight-black"
            >Lihat Lebih Lanjut</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog> -->
    <v-dialog v-model="showRegVaDialog" persistent max-width="355">
      <v-card>
        <v-card-title class="subtitle-1">
          Siapkan KTP dan Email eksternal Anda. Ingin melakukan registrasi VA sekarang?
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            style="border-color: yellow"
            outlined
            color="black"
            depressed
            @click="showRegVaDialog = false"
            class="font-weight-black"
          >
            Nanti saja
          </v-btn>
          <v-btn
            color="yellow"
            depressed
            @click="handleRegVaDialog"
            class="font-weight-black"
            >Ya</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :value="isLoading" z-index="999">
      <v-progress-circular indeterminate color="primary"> </v-progress-circular>
    </v-overlay>
  </v-app>
</template>

<script>
import Header from "@/components/Header/Header";
import Sidebar from "@/components/Sidebar/Sidebar";
import { mapActions } from "vuex";
// import Footer from "@/components/Footer/Footer";
import "./Layout.scss";

export default {
  name: "Layout",
  data: function () {
    return {
      absolute: true,
      renderComponent: true,
    }
  },
  components: { Header, Sidebar },
  methods: {
    ...mapActions(["refreshToken", "getFeatures"]),
    handleRegVaDialog: function () {
      this.$store.commit("showRegVaDialog", false);
      this.$store.commit("setJustLoggedIn", false);
      this.$router.push({ name: "vaRegistration" });
    },
    handlePopUpNotificationDialog: function () {
      this.$store.commit("showPopUpNotificationDialog", false);
      this.$store.commit("setJustLoggedIn", false);
      this.$router.push({ name: "programInformationDetail" });
    },
    forceRerender() {
        // Remove my-component from the DOM
        this.renderComponent = false;

        this.$nextTick(() => {
          // Add the component back in
          this.renderComponent = true;
        });
      },
      // refreshTokens() {
      //   //setInterval(function () {
      //   console.log('APAKAH MASUK SINI')
      //   this.refreshToken({
      //   refreshToken: localStorage.getItem('refreshToken'),
      //     username: localStorage.getItem('username'),
      // })
      // this.$store
      //   .dispatch("refreshToken", {
      //     refreshToken: localStorage.getItem('refreshToken'),
      //     username: localStorage.getItem('username'),
      //   })
        // .then((response) => {
        //   return this.$helpers.handleSuccess(response);
        // })
        // .catch((err) => {
        //   this.$helpers.handleError(err);
        // });
        //}, 5000)
      // }
  },
  computed: {
    showSnackbar: {
      get: function () {
        return this.$store.getters.showSnackbar;
      },
      set: function () {
        this.$store.commit("hideSnackBar");
      },
    },
    snackbarMsg: {
      get: function () {
        return this.$store.getters.snackbarMsg;
      },
      set: function () {
        this.$store.commit("resetSnackBarMsg");
      },
    },
    showDialog: {
      get: function () {
        return this.$store.getters.showDialog;
      },
      set: function () {
        this.$store.commit("hideDialog");
      },
    },
    dialogMsg: {
      get: function () {
        return this.$store.getters.dialogMsg;
      },
      set: function () {
        this.$store.commit("resetDialog");
      },
    },
    snackbarColor: {
      get: function () {
        return this.$store.getters.snackbarColor;
      },
      set: function () {
        this.$store.commit("resetSnackBarColor");
      },
    },
    showRegVaDialog: {
      get: function () {
        return this.$store.getters.showRegVaDialog;
      },
      set: function (newValue) {
        this.$store.commit("showRegVaDialog", newValue);
      },
    },
    showPopUpNotificationDialog: {
      get: function () {
        return this.$store.getters.showPopUpNotificationDialog;
      },
      set: function (newValue) {
        this.$store.commit("showPopUpNotificationDialog", newValue);
      },
    },
    isLoading () {
      return this.$store.getters.isLoading;
    }
  },
  mounted() {
    this.$store.commit('stopLoading')//Stopping stucked loading indicator
    //cek butuh registrasi va atau di redirect ke change default pin
    if (Object.keys(this.$store.state.features).length > 0) {
      //get first object

      // const generalInfo = this.$store.state.features[0];
      
      // console.log('general info', generalInfo)
      // console.log('generalInfo.regVAFlag === false', generalInfo.regVAFlag === false)

      //COMMENT TEMPORARY
      // if (generalInfo.regVAFlag === false && this.$store.state.justLoggedIn) {
      //   // console.log('masuk sini')
      //   this.$store.commit("showRegVaDialog", true);
      // }

      if (this.$store.state.justLoggedIn) {
        this.$store.commit("showPopUpNotificationDialog", true);
      }
      // console.log('generalInfo.changeDefaultPinFlag', generalInfo)
      // if (
      //   generalInfo.changeDefaultPinFlag === false &&
      //   this.$store.state.justLoggedIn
      // ) {
      //   if (this.$route.name !== "resetPin")
      //     this.$router.push({ name: "resetPin" });
      // }
      //setInterval(function() {
        // this.refreshTokens()
        //}, 5000)

      this.getFeatures()

      //load profile
      this.$store
        .dispatch("getProfile")
        .then((response) => {
          return this.$helpers.handleSuccess(response);
        })
        .catch((err) => {
          this.$helpers.handleError(err);
        });

      //load cart items
      // this.$store
      //   .dispatch("getCart", {
      //     pageNumber: 0,
      //     pageSize: 1000, //sementara di set 100
      //     searchVal: "",
      //     status: "CIS_NEW",
      //   })
      //   .then((response) => {
      //     return this.$helpers.handleSuccess(response);
      //   })
      //   // .then((response) => {
      //   //   console.log("isi data cart", response.data);
      //   // })
      //   .catch((err) => {
      //     this.$helpers.handleError(err);
      //   });

    } else {
      console.log("have not features");
    }
  },
};
</script>

<style src="./Layout.scss" lang="scss" />

